import classes from "./Home.module.css";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { collection, getDocs, limit, query, orderBy } from "firebase/firestore";
import { db } from "../index";
import Shimmer from "./Shimmer";
import Product from "./Product";

export default function Home() {
	const navigate = useNavigate("");

	// state for loaded categories
	const [categories, setCategories] = useState([]);

	//state for loaded products
	const [products, setProducts] = useState([]);

	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	//welcome message
	const [welcomeMsg, setWelcomeMsg] = useState("");

	//hover state for categoies
	const [hover, setHover] = useState(false);

	//effect for loading category from db
	useEffect(() => {
		const loadCategories = async () => {
			setLoading(true);
			try {
				const loadedCategories = await getDocs(
					collection(db, "categories")
				);
				const categoryArray = [];
				loadedCategories.forEach((eachCategory) =>
					categoryArray.push({
						id: eachCategory.id,
						...eachCategory.data(),
					})
				);
				setCategories(categoryArray);
			} catch (error) {
				console.error(error);
				setError(true);
			} finally {
				setLoading(false);
			}
		};
		loadCategories();
	}, []);

	useEffect(() => {
		const loadItems = async () => {
			try {
				setLoading(true);
				const query_args = query(
					collection(db, "items"),
					limit(12),
					orderBy("timestamp", "desc")
				);
				const loadedItems = await getDocs(query_args);
				const itemsArray = [];
				loadedItems.forEach((eachItem) =>
					itemsArray.push({ id: eachItem.id, ...eachItem.data() })
				);
				setProducts(itemsArray);
			} catch (error) {
				console.error(error);
				setError(true);
			} finally {
				setLoading(false);
			}
		};
		loadItems();
	}, []);

	//effect for mananging site loading state
	useEffect(() => {
		const msg = `Welcome to DC WEARS
		Elevate your style with Timeless Fashion and Unwavering Quality`;
		let current_position = 1;

		let interval = setInterval(() => {
			let current = msg.substring(0, current_position);
			setWelcomeMsg(current);

			if (current_position === msg.length) {
				clearInterval(interval);
				interval = null;
			}
			current_position++;
		}, 100);

		return () => {
			if (!interval) {
				return;
			}

			clearInterval(interval);
			interval = null;
		};
	}, []);

	return (
		<>
			<Container fluid>
				<Row>
					<Col>
						<div
							className={classes.wallPaper}
							style={{
								backgroundImage:
									'url("/images/homewallpaper.jpg")',
							}}
						>
							<p>{welcomeMsg}</p>
						</div>
					</Col>
				</Row>
			</Container>


			{/* Loading UI for categories */}
			{loading && (
				<Container className="mt-6">
					<div className={classes.latestArrivals}>
						<Row>
							{Array(4)
								.fill(0)
								.map((_, index) => (
									<Col xs={12} md={6} xl={3} key={index}>
										<Shimmer />
									</Col>
								))}
						</Row>
					</div>
				</Container>
			)}

			{/* Displaying categories UI*/}
			<Container className="mt-3">
				<Row>
					{categories.map((category, index) => (
						<Col xs={12} md={6} xl={3} xxl={2} className="mt-3" key={index}>
							<div className={classes.category}>
								<div
									className={classes.image}
									style={{
										backgroundImage: `url(${category.image})`,
									}}
									onClick={() => navigate(`/category/${category.id}`)}
									onMouseEnter={() => setHover(true)}
									onMouseLeave={() => setHover(false)}
								>
									{hover && (
										<div className={classes.categoryText}>
											{category.name}
										</div>
									)}
								</div>
								<Button
									variant="success"
									onClick={() => navigate(`/${category.id}`)}
								>
									View {category.name}'s Category
								</Button>
							</div>
						</Col>
					))}
				</Row>
			</Container>

			{/* Loading UI for latest arrivals */}
			{loading && (
				<Container className="mt-6">
					<div className={classes.latestArrivals}>
						<div
							style={{
								padding: "1rem",
								fontFamily: "Libre Baskerville, sans-serif",
							}}
						>
							<p>Latest Arrivals</p>
						</div>
						<Row>
							{Array(12)
								.fill(0)
								.map((_, index) => (
									<Col
										xs={6}
										sm={4}
										md={3}
										lg={3}
										xl={3}
										xxl={2}
										key={index}
									>
										<Shimmer />
									</Col>
								))}
						</Row>
					</div>
				</Container>
			)}


			{/* UI for latest arrivals */}
			{!loading && !error && (
				<Container className="mt-6">
					<div className={classes.latestArrivals}>
						<div
							style={{
								padding: "1rem",
								fontFamily: "Libre Baskerville, sans-serif",
							}}
						>
							<p>Latest Arrivals</p>
						</div>
						<Row>
							{products.map((eachProduct) => (
								<Col
									xs={6}
									sm={4}
									md={3}
									lg={3}
									xl={3}
									xxl={2}
									key={eachProduct.id}
								>
									<Product {...eachProduct} />
								</Col>
							))}
						</Row>
					</div>
				</Container>
			)}
		</>
	);
}
